import { useSetAtom } from "jotai";
import { useTranslation } from "react-i18next";

import { useAlert } from "@/hooks/useAlert";
import { useIsAnonymousUser } from "@/hooks/useIsAnonymousUser";
import { PUBLIC_AUTHORIZATION, TOKEN_URL } from "@/utils/apiUrls";
import { accessTokenAtom, AlertTypes } from "@/utils/atoms";

/**
 * Authenticates as a public user and sets the access token.
 *
 * This hook retrieves an access token for a public user from the backend
 * It's a simpler version of useAnonymousLogin that only handles authentication
 * withoutany additional operations.
 */
export const usePublicCustomerLogin = () => {
  const setAccessToken = useSetAtom(accessTokenAtom);
  const [, setIsAnonymousUser] = useIsAnonymousUser();
  const showAlert = useAlert();
  const { t } = useTranslation();

  const logInAsPublicCustomer = () =>
    // Get an OAuth token by using the public user
    fetch(`${TOKEN_URL.toString()}?grant_type=client_credentials&scope=all`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: PUBLIC_AUTHORIZATION,
      },
    })
      .then(async (res: any) => {
        const anonymousLoginData = await res.json();

        if (anonymousLoginData.access_token === undefined) {
          throw new Error("No access token received");
        }

        setAccessToken(anonymousLoginData.access_token);
        setIsAnonymousUser(true);
      })
      .catch((e) => {
        showAlert({
          text: t("Error.agentLogin.failed"),
          type: AlertTypes.error,
        });
      });

  return logInAsPublicCustomer;
};
